/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesEmailNotificationPreference } from './WebApiModelsEnumerationTypesEmailNotificationPreference';
import {
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSONTyped,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON,
} from './WebApiModelsEnumerationTypesEmailNotificationPreference';

/**
 * 
 * @export
 * @interface WebApiMemberDtoGetMemberByPasswordCodeResultDto
 */
export interface WebApiMemberDtoGetMemberByPasswordCodeResultDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    uniqueId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    email2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    phone2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    adressRow2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    adressRow3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    personalNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    webPage?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    dateJoined?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    streetAdress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    postalArea?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    company?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    extra1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    extra2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    extra3?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    hasPaidCurrentYear?: boolean;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEmailNotificationPreference}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    emailNotificationPreference?: WebApiModelsEnumerationTypesEmailNotificationPreference;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    token?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoGetMemberByPasswordCodeResultDto
     */
    customFieldsJson?: string | null;
}

/**
 * Check if a given object implements the WebApiMemberDtoGetMemberByPasswordCodeResultDto interface.
 */
export function instanceOfWebApiMemberDtoGetMemberByPasswordCodeResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberDtoGetMemberByPasswordCodeResultDtoFromJSON(json: any): WebApiMemberDtoGetMemberByPasswordCodeResultDto {
    return WebApiMemberDtoGetMemberByPasswordCodeResultDtoFromJSONTyped(json, false);
}

export function WebApiMemberDtoGetMemberByPasswordCodeResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberDtoGetMemberByPasswordCodeResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uniqueId': !exists(json, 'uniqueId') ? undefined : json['uniqueId'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'email2': !exists(json, 'email2') ? undefined : json['email2'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'phone2': !exists(json, 'phone2') ? undefined : json['phone2'],
        'adressRow2': !exists(json, 'adressRow2') ? undefined : json['adressRow2'],
        'adressRow3': !exists(json, 'adressRow3') ? undefined : json['adressRow3'],
        'personalNumber': !exists(json, 'personalNumber') ? undefined : json['personalNumber'],
        'webPage': !exists(json, 'webPage') ? undefined : json['webPage'],
        'dateJoined': !exists(json, 'dateJoined') ? undefined : (json['dateJoined'] === null ? null : new Date(json['dateJoined'])),
        'streetAdress': !exists(json, 'streetAdress') ? undefined : json['streetAdress'],
        'postalCode': !exists(json, 'postalCode') ? undefined : json['postalCode'],
        'postalArea': !exists(json, 'postalArea') ? undefined : json['postalArea'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'company': !exists(json, 'company') ? undefined : json['company'],
        'extra1': !exists(json, 'extra1') ? undefined : json['extra1'],
        'extra2': !exists(json, 'extra2') ? undefined : json['extra2'],
        'extra3': !exists(json, 'extra3') ? undefined : json['extra3'],
        'hasPaidCurrentYear': !exists(json, 'hasPaidCurrentYear') ? undefined : json['hasPaidCurrentYear'],
        'emailNotificationPreference': !exists(json, 'emailNotificationPreference') ? undefined : WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON(json['emailNotificationPreference']),
        'token': !exists(json, 'token') ? undefined : json['token'],
        'customFieldsJson': !exists(json, 'customFieldsJson') ? undefined : json['customFieldsJson'],
    };
}

export function WebApiMemberDtoGetMemberByPasswordCodeResultDtoToJSON(value?: WebApiMemberDtoGetMemberByPasswordCodeResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uniqueId': value.uniqueId,
        'email': value.email,
        'email2': value.email2,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'phone': value.phone,
        'phone2': value.phone2,
        'adressRow2': value.adressRow2,
        'adressRow3': value.adressRow3,
        'personalNumber': value.personalNumber,
        'webPage': value.webPage,
        'dateJoined': value.dateJoined === undefined ? undefined : (value.dateJoined === null ? null : value.dateJoined.toISOString().substr(0,10)),
        'streetAdress': value.streetAdress,
        'postalCode': value.postalCode,
        'postalArea': value.postalArea,
        'title': value.title,
        'country': value.country,
        'company': value.company,
        'extra1': value.extra1,
        'extra2': value.extra2,
        'extra3': value.extra3,
        'hasPaidCurrentYear': value.hasPaidCurrentYear,
        'emailNotificationPreference': WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON(value.emailNotificationPreference),
        'token': value.token,
        'customFieldsJson': value.customFieldsJson,
    };
}

